function Header() {
  return (
    <div className="w-full flex flex-col items-center pt-14 pb-20">
      <h1 className="text-custom_black">آخرین پروژه ها</h1>
      <p className="text-sm sm:text-base xl:font-extralight text-custom_pink">
        آخرین پروژه های کامل شده و یا درحال توسعه من
      </p>
    </div>
  );
}

export default Header;